import { format } from 'date-fns';

const Timeline = ({ day, children }) => {

    return (
        <div className="calendar__timeline">
            <div className="calendar__timeline-header">
                <div className="calendar__timeline-title">
                    <span>{format(day, "dd")}th</span>,
                    <span style={{ color: "#F89624" }}>{format(day, "EE")}</span>
                </div>
            </div>
            <div className="calendar__timeline-hours">
                {children}
            </div>
        </div>
    );
};

export default Timeline;
